module.exports = __webpack_public_path__ + "static/media/25.6fced3e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/25.png
// module id = 528
// module chunks = 0